<template>
  <div class="profile-wrapper">
    <router-link class="close-button" to="/">
      <img src="@/assets/icons/other/close.svg">
    </router-link>
    <div
      class="header"
      :style="`padding-top: ${SafeAreaView.top + 50}px`"
    >
      <ProfilePicture :user="user" />
      <RouterLink
        v-if="!user?.name"
        to="/profile"
        class="name name--empty"
      >
        {{ t('menu.addName') }}
      </RouterLink>
      <div
        v-else
        class="name"
      >
        {{ user.name }}
      </div>
      <div class="phone">
        {{ userPhone || '&nbsp;' }}
      </div>
    </div>

    <div class="menu-list">
      <ListItem
        :icon="UserIcon"
        :title="t('menu.profile')"
        to="/profile"
      />
      <ListItem
        :icon="CompanyIcon"
        :title="t('menu.myCompanies')"
        to="/companies"
      />
      <ListItem
        :icon="PetIcon"
        :title="t('menu.myPets')"
        to="/animals"
      />
      <ListItem
        :icon="SettingsIcon"
        :title="t('menu.preferencies')"
        to="/preferencies"
      />
      <ListItem
        :icon="QuestionIcon"
        :title="t('menu.support')"
        to="/support"
      />
    </div>
  </div>
</template>

<script setup>
import { useUserStore, useUserData } from '@/states/userStore';

import { SafeAreaView } from '@/helpers/getSafeArea'
import ProfilePicture from '@/components/ProfilePicture.vue';

import UserIcon from '@/assets/icons/other/user-gray.svg'
import CompanyIcon from '@/assets/icons/other/company-gray.svg'
import PetIcon from '@/assets/icons/other/pet-gray.svg'
import SettingsIcon from '@/assets/icons/other/settings-gray.svg'
import QuestionIcon from '@/assets/icons/other/question-gray.svg'

import ListItem from './ListItem.vue';

const { getUser } = useUserStore();
const { user, userPhone } = useUserData();

getUser()

</script>

<style lang="scss" scoped>
.profile-wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: #f3f4f8;
}

.header {
  width: 100%;
  min-height: 300px;
  box-sizing: border-box;
  padding: 50px 20px 24px;
  background: #9ad03b;
  border-radius: 0 0 32px 32px;

  @include flex-center();
  flex-direction: column;
}

.name {
  font-size: 24px;
  color: #000;
  @include font-semibold;

  margin-bottom: 6px;
}

.name--empty {
  font-size: 20px;
  color: #26384b;
  text-decoration: underline;
}

.phone {
  font-size: 14px;
  color: #8E92AF;
  @include font-bold;
}

.menu-list {
  padding-top: 32px;
}

// аватар по макету: белый скруглённый квадрат без рамки, в том числе в тёмной теме
.header :deep(.picture) {
  width: 118px;
  height: 118px;
  border: none;
  border-radius: 40px;
  background-color: #fff;
}

.close-button {
  @include flex-center;
  background: white;
  border-radius: 50%;
  width: 48px;
  height: 48px;

  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 2;
}

[theme="dark"] {
  .profile-wrapper {
    background: #1b1b1b;
  }

  .close-button {
    background-color: #37363c;
  }
}
</style>
